import { useContext } from 'react';
import { RecurringPaymentComponentContext } from './recurring-payment-component.context';

const useComponentContext =() => {
  return useContext(RecurringPaymentComponentContext);
}

export default useComponentContext;